'use client'

import React from 'react'
import { useMyCIOLanguageOrCookie } from '@/lib/mycio/MyCIOLanguageContext'
import { getMyCIOShellChromeCopy } from '@/lib/mycio/copy/shellChrome'

interface SkipLinksProps {
  links?: Array<{
    href: string
    text: string
  }>
}

const SkipLinks: React.FC<SkipLinksProps> = ({ links: given }) => {
  // Rendered by the root layout, outside the language provider: the language comes from the cookie.
  const t = getMyCIOShellChromeCopy(useMyCIOLanguageOrCookie()).skipLinks
  const links = given ?? [
    { href: '#main-content', text: t.main },
    { href: '#navigation', text: t.navigation },
    { href: '#search', text: t.search },
  ]
  return (
    <div className="skip-links">
      {links.map((link, index) => (
        <a
          key={index}
          href={link.href}
          className="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-50 focus:bg-white focus:text-black focus:p-2 focus:rounded focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          onClick={(e) => {
            e.preventDefault()
            const target = document.querySelector(link.href)
            if (target) {
              ;(target as HTMLElement).focus()
              target.scrollIntoView({ behavior: 'smooth' })
            }
          }}
        >
          {link.text}
        </a>
      ))}
    </div>
  )
}

export default SkipLinks

// Add this to your global CSS or Tailwind config
export const skipLinkStyles = `
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .focus\\:not-sr-only:focus {
    position: static;
    width: auto;
    height: auto;
    padding: 0.5rem;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }
`